import{isArray as r}from"../Guard/isArray.js";var n=function(n){if(!function(n){return r(n)}(n))return n;for(var t={},o=0,u=n;o<u.length;o++){var a=u[o];t[a]=a}return t};export{n as enumeration};
//# sourceMappingURL=enumeration.js.map
